// extracted by mini-css-extract-plugin
export default {"body":"PopupBodyComponent_body__xyZaN","body_large":"PopupBodyComponent_body_large__cRNPT"};